export default __webpack_public_path__ + "static/media/icon-heart.7bfab16c.png";